import { useUser, useAuth } from '@clerk/clerk-react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LectureDownloaderProps {
  lectureName: string;
  fileName: string;
}

export function LectureDownloader({ lectureName, fileName }: LectureDownloaderProps) {
  const { user } = useUser();
  const { getToken } = useAuth();
  
  // Only show download for specific authorized user
  if (!user || user.primaryEmailAddress?.emailAddress !== 'anant@nextgenerationmedicine.co') {
    return null;
  }

  const handleDownload = async () => {
    try {
      // Get the session token from Clerk
      const token = await getToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch(`/api/lectures/download/${fileName}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to download file');
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `${fileName}.tsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleDownload}
      className="ml-4 bg-blue-50 hover:bg-blue-100 border-blue-200"
    >
      <Download className="h-4 w-4 mr-2" />
      Download TSX
    </Button>
  );
}